/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { AttributeValue } from '@msdyn365-commerce/retail-proxy';

/**
 * GetCmsListLibraryDashboard Input Action
 */
export class GetCmsListMyLibraryDashboardInput implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
    constructor() {}

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `CMS_LIST_MY_LIBRARY_DASHBOARD`;
    public getCacheObjectType = () => 'CMS_LIST_MY_LIBRARY_DASHBOARD';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetCmsListMyLibraryDashboardData {
    totalItem: any;
    dataLibrary: AttributeValue[];
    mess: string | null;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetCmsListMyLibraryDashboardInput();
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function action(
    input: GetCmsListMyLibraryDashboardInput,
    ctx: Msdyn365.IActionContext
): Promise<GetCmsListMyLibraryDashboardInput | void> {
    let searchParam: string = '';
    let userId: string | undefined = ctx.requestContext.user.customerAccountNumber;
    if (ctx && ctx.requestContext && ctx.requestContext.url) {
        if (ctx.requestContext.url.requestUrl) {
            searchParam = ctx.requestContext.url.requestUrl.search;
        }
    }
    if (userId === undefined) {
        userId = '1';
    }
    const frontApiEndpoint = ctx.requestContext.app.config.cmsAPIEndpoint && ctx.requestContext.app.config.cmsAPIEndpoint;
    const requestUrl = `${frontApiEndpoint}/api/list/library/dashboard/${userId}/en${searchParam}`;
    const result = await Msdyn365.sendRequest<GetCmsListMyLibraryDashboardInput>(requestUrl, 'get')
        .then(response => {
            return response.data;
        })
        .catch(error => {
            ctx.trace('[GetCmsListMyLibraryDashboard] Failed to get list my libary on dashboard.');
            throw error;
        });
    return result;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetCmsListMyLibraryDashboardData>>(<unknown>action),
    // TODO: Give your data action a unique id
    id: 'GetCmsListMyLibraryDashboard',
    input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
